module.exports = __webpack_public_path__ + "img/1560885619.cf82f506.jpg";